import React, { useState, useEffect } from 'react';
import './Users.css';

const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const Users = () => {
// State for users and form
const [users, setUsers] = useState([]);
const [searchTerm, setSearchTerm] = useState('');

  // Load initial data (simulated)
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try{
      const response = await fetch(`${SERVER_URL}/api/auth/users`);
      const result = await response.json();
      setUsers(result.users);
    }   
    catch(error) {
      console.error('There was a problem with the fetch operation:', error);
    };
  };

  // Delete user
  const deleteUser = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to delete this user?')) {
      // setUsers(users.filter(user => user.id !== id));
      await fetch(`${SERVER_URL}/api/auth/deleteUser/${id}`);
      setUsers(users.filter(user => user._id !== id));
      
      // toast.success('User Removed Successfully!');  
      fetchData()
    }
  };

  // Filter users based on search term
  const filteredUsers = users.filter(user => 
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
 
    <div className="user-management">
      
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
              
      <div className="users-table-container">
        <h3>Users List</h3>
        {users.length > 0 ? (
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Contact Number</th>
                <th>Email</th>
                <th>Medical Histroy</th>
                <th>Address</th>
                <th>City</th>
                <th>DateOfBirth</th>
                <th>Registered Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user,index) => (
                <tr key={user._id}>
                  <td>{index+1}</td>
                  <td>{user.name}</td>
                  <td>{user.contactNumber}</td>
                  <td>{user.email}</td>
                  <td>{user.medicalHistory}</td>
                  <td>{user.address}</td>
                  <td>{user.city}</td>
                  <td>{new Date(user.dateOfBirth).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'})}</td>
                  <td>{new Date(user.createdAt).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'})}</td>
                  <td className="actions-cell">
                    <button
                      className="btn-delete"
                      onClick={() => deleteUser(user._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-users">No users found.</p>
        )}
      </div>
    </div>
        
  );
};

export default Users;